
        import * as module0 from './controllers/analytics_controller.js';import * as module1 from './controllers/newsletter_sheet_controller.js'
        const modules = {
            "./controllers/analytics_controller.js": module0,
            "./controllers/newsletter_sheet_controller.js": module1,
        };
        export default modules;
      